export default __webpack_public_path__ + "static/media/05.9861d22b.webp";